import { render, staticRenderFns } from "./Installation.vue?vue&type=template&id=1c86be43&scoped=true&"
import script from "./Installation.vue?vue&type=script&lang=js&"
export * from "./Installation.vue?vue&type=script&lang=js&"
import style0 from "./Installation.vue?vue&type=style&index=0&id=1c86be43&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c86be43",
  null
  
)

export default component.exports